"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENotificationActionType = exports.ENotificationType = void 0;
var ENotificationType;
(function (ENotificationType) {
    ENotificationType["COMMENT"] = "COMMENT";
    ENotificationType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    ENotificationType["FRIEND_REQUEST"] = "FRIEND_REQUEST";
})(ENotificationType = exports.ENotificationType || (exports.ENotificationType = {}));
var ENotificationActionType;
(function (ENotificationActionType) {
    ENotificationActionType["REPLY"] = "REPLY";
    ENotificationActionType["LIKE"] = "LIKE";
    ENotificationActionType["DISLIKE"] = "DISLIKE";
    ENotificationActionType["FEATURE"] = "FEATURE";
    ENotificationActionType["INFORMATION"] = "INFORMATION";
    ENotificationActionType["REQUESTED"] = "REQUESTED";
    ENotificationActionType["ACCEPTED"] = "ACCEPTED";
})(ENotificationActionType = exports.ENotificationActionType || (exports.ENotificationActionType = {}));
